import { Button, Dropdown, Form, FormInstance, MenuProps, Row } from "antd";
import { useCallback, useMemo } from "react";
import { DownOutlined } from "@ant-design/icons";

type CommentOptionsProps = {
  form: FormInstance;
};

export const CommentOptions = ({ form }: CommentOptionsProps) => {
  const commentValue = Form.useWatch("comments", form);

  const options: any[] = useMemo(
    () => [
      {
        key: "Multiple Payments",
        value: "Please apply this payment to multiple payments.",
      },
      {
        key: "Extra to Principal",
        value: "Please apply this payment as extra to principal.",
      },
      {
        key: "Principal Only",
        value: "Please apply this payment to principal only.",
      },
      {
        key: "Regular Payment and Late Fee",
        value: "Please apply this payment to regular payment and late fee.",
      },
      {
        key: "Late Fee Only",
        value: "Please apply this payment to late fee only.",
      },
      {
        key: "Impound Only",
        value: "Please apply this payment to impound only.",
      },
    ],
    [],
  );

  const onSelect = useCallback(
    (value: string) => {
      form.setFieldValue("comments", value);
    },
    [form],
  );

  const items: MenuProps["items"] = useMemo(
    () =>
      [3, 4, 5].map((index: number) => ({
        key: index.toString(),
        label: (
          <div onClick={() => onSelect(options[index].value)}>
            {options[index].key}
          </div>
        ),
      })),
    [onSelect, options],
  );

  return (
    <Row className="mb-2">
      {[0, 1, 2].map((index: number) => (
        <Button
          key={index}
          className={`mr-2 mb-2 ${commentValue === options[index].value ? "ant-button-checked" : ""}`}
          shape="round"
          onClick={() => onSelect(options[index].value)}
        >
          {options[index].key}
        </Button>
      ))}
      <Dropdown menu={{ items }} trigger={["click"]}>
        <Button
          shape="round"
          className={`mb-2 ${[3, 4, 5].some((index) => commentValue === options[index].value) ? "ant-button-checked" : ""}`}
        >
          Other
          <DownOutlined />
        </Button>
      </Dropdown>
    </Row>
  );
};
